import { ComponentProps } from 'react'

interface InputProps {
  label: string
  placeholder: string
  message?: string
  id: string
  className?: string
  type?: 'textarea' | 'text'
  rows?: number
}

export const Input = ({
  label,
  placeholder,
  message,
  id,
  type = 'text',
  rows,
  className,
  ...props
}: InputProps & (ComponentProps<'input'> | ComponentProps<'textarea'>)) => {
  const { ref: _, ...typedProps } = props
  return (
    <div className="mb-4">
      <label className="block text-cv-blue-900 text-base font-medium mb-[6px]" htmlFor={id}>
        {label}
      </label>
      {type === 'textarea' ? (
        <textarea
          id={id}
          rows={rows || 4}
          placeholder={placeholder}
          className={`text-base appearance-none border border-cv-blue-200 rounded-md w-full py-2 px-3 placeholder-text-cv-blue-400 text-cv-blue-700 leading-tight focus:outline-none focus:shadow-outline ${className}`}
          {...(typedProps as ComponentProps<'textarea'>)}
        />
      ) : (
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          className={`text-base appearance-none border border-cv-blue-200 rounded-md w-full py-2 px-3 placeholder-text-cv-blue-400 text-cv-blue-700 leading-tight focus:outline-none focus:shadow-outline ${className}`}
          {...(typedProps as ComponentProps<'input'>)}
        />
      )}
      {message && <p className="text-cv-blue-400 text-sm mt-[6px]">{message}</p>}
    </div>
  )
}
